/* GrowersHouse 2026 — header menu, mobile drawer, sliders. No dependencies. */
(function () {
  'use strict';
  if (window.__ghInit) return;
  window.__ghInit = true;

  /* ---------- Desktop dropdown / mega menu ---------- */
  function initNav(root) {
    var items = root.querySelectorAll('.gh-nav__item--parent');
    var desktop = window.matchMedia('(min-width: 990px)');
    var closeTimer;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var btn = item.querySelector('.gh-nav__toggle');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      items.forEach(function (i) { if (i !== except) setOpen(i, false); });
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.gh-nav__toggle');
      item.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!desktop.matches) return;
        closeTimer = setTimeout(function () { setOpen(item, false); }, 140);
      });
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var open = !item.classList.contains('is-open');
          closeAll(item);
          setOpen(item, open);
          if (open) {
            var first = item.querySelector('.gh-panel a');
            if (first && e.detail === 0) first.focus();
          }
        });
      }
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (i) {
        if (i.classList.contains('is-open')) {
          setOpen(i, false);
          var b = i.querySelector('.gh-nav__toggle');
          if (b) b.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer(root) {
    var drawer = root.querySelector('.gh-drawer');
    var openBtn = root.querySelector('.gh-menu-btn');
    if (!drawer || !openBtn) return;
    var panel = drawer.querySelector('.gh-drawer__panel');

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      drawer.removeAttribute('inert');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('gh-no-scroll');
      setTimeout(function () {
        var f = drawer.querySelector('.gh-drawer__close');
        if (f) f.focus();
      }, 50);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('gh-no-scroll');
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-gh-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('a[href],button,select,input,summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) {
      if (m.matches && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Market (country) selector ---------- */
  function initMarkets(root) {
    root.querySelectorAll('.gh-market select').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- Sliders ---------- */
  function initSlider(section) {
    var slider = section.querySelector('.gh-slider');
    var prev = section.querySelector('.gh-slide-prev');
    var next = section.querySelector('.gh-slide-next');
    if (!slider || !prev || !next) return;
    function update() {
      prev.disabled = slider.scrollLeft <= 2;
      next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
    }
    function move(dir) {
      var card = slider.firstElementChild;
      if (!card) return;
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      slider.scrollBy({ left: dir * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Read more / read less (collapsible content) ---------- */
  function initReadMore(wrap) {
    var body = wrap.querySelector('[data-gh-readmore-body]');
    var btn = wrap.querySelector('[data-gh-readmore-btn]');
    if (!body || !btn) return;
    var limit = parseInt(wrap.getAttribute('data-gh-readmore'), 10) || 220;
    if (body.scrollHeight <= limit + 60) {
      btn.hidden = true;
      /* Images or custom HTML can grow the content after load: check once more */
      if (!wrap.dataset.ghRecheck) {
        wrap.dataset.ghRecheck = '1';
        window.addEventListener('load', function () { initReadMore(wrap); }, { once: true });
      }
      return;
    }
    function set(open) {
      wrap.classList.toggle('is-collapsed', !open);
      body.style.maxHeight = open ? 'none' : limit + 'px';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? (btn.getAttribute('data-less') || 'Read less') : (btn.getAttribute('data-more') || 'Read more');
    }
    btn.hidden = false;
    wrap.classList.add('is-collapsible');
    set(false);
    btn.addEventListener('click', function () {
      var open = wrap.classList.contains('is-collapsed');
      set(open);
      if (!open) wrap.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  function initAll(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-gh-readmore]').forEach(function (w) {
      if (w.dataset.ghReady) return;
      w.dataset.ghReady = '1';
      initReadMore(w);
    });
    scope.querySelectorAll('[data-gh-header]').forEach(function (h) {
      if (h.dataset.ghReady) return;
      h.dataset.ghReady = '1';
      initNav(h); initDrawer(h); initMarkets(h);
    });
    scope.querySelectorAll('[data-gh-slider]').forEach(function (s) {
      if (s.dataset.ghReady) return;
      s.dataset.ghReady = '1';
      initSlider(s);
    });
    scope.querySelectorAll('[data-gh-footer]').forEach(initMarkets);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Keep our search placeholder (Boost AI Search resets it to "Search" when it binds) */
  function keepPlaceholders() {
    document.querySelectorAll('.gh-search input[name=q]').forEach(function (i) {
      if (i.dataset.ghPhWatch) return;
      i.dataset.ghPhWatch = '1';
      var want = i.dataset.ghPlaceholder || i.getAttribute('placeholder');
      i.dataset.ghPlaceholder = want || '';
      var fix = function () { if (want && i.getAttribute('placeholder') !== want) i.setAttribute('placeholder', want); };
      new MutationObserver(fix).observe(i, { attributes: true, attributeFilter: ['placeholder'] });
      fix();
    });
  }
  keepPlaceholders();
  document.addEventListener('DOMContentLoaded', keepPlaceholders);
  document.addEventListener('shopify:section:load', keepPlaceholders);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
